import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9313cd8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view users" }
const _hoisted_2 = { class: "users__header" }
const _hoisted_3 = { class: "users__header-left" }
const _hoisted_4 = { class: "users__title" }
const _hoisted_5 = { class: "users__count" }
const _hoisted_6 = { class: "users__header-right" }
const _hoisted_7 = { class: "search" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons search__icon" }, "search", -1))
const _hoisted_9 = { class: "users__utils" }
const _hoisted_10 = { class: "users__utils-left" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Add users ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "person_add", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "users__utils-right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "file_upload", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Export all users")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "users__table"
}
const _hoisted_19 = {
  key: 0,
  class: "users__table-utils"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "bug_report", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Set debug option for all")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "file_upload", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Export results")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "delete", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Delete users permanently")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "users__table-row" }
const _hoisted_30 = { class: "users__table-cell table__check" }
const _hoisted_31 = { class: "users__table-cell table__email" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Username ")
const _hoisted_33 = { class: "users__table-cell table__name" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("First name ")
const _hoisted_35 = { class: "users__table-cell table__user-type" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("User type ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__access-code" }, "Access code", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__debug" }, "Debug option", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__table-cell table__groups" }, "Groups", -1))
const _hoisted_40 = { class: "users__table-body" }
const _hoisted_41 = { class: "users__table-cell table__check" }
const _hoisted_42 = { class: "users__table-cell table__email" }
const _hoisted_43 = { class: "users__table-cell table__name" }
const _hoisted_44 = { class: "users__table-cell table__user-type" }
const _hoisted_45 = { class: "users__table-pill pill pill--blue" }
const _hoisted_46 = { class: "users__table-cell table__access-code" }
const _hoisted_47 = { class: "users__table-cell table__debug" }
const _hoisted_48 = { class: "users__table-cell table__groups" }
const _hoisted_49 = { class: "users__utils" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__utils-left" }, null, -1))
const _hoisted_51 = { class: "users__utils-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.groupName ? _ctx.groupName : 'Users') + " ", 1),
          _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(_ctx.userCount) + ")", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "search__input",
            placeholder: "Type to search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableBody.searchValue) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchUsers && _ctx.searchUsers(...args)))
          }, null, 544), [
            [_vModelText, _ctx.tableBody.searchValue]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "users__add button button--blank",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addUser()))
        }, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "users__add button button--blank",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportUsers && _ctx.exportUsers(...args)), ["prevent"]))
        }, _hoisted_17),
        _createVNode(_component_Pagination, {
          options: _ctx.tableBody,
          maxCount: _ctx.userCount,
          onPaginChange: _ctx.paginChange
        }, null, 8, ["options", "maxCount", "onPaginChange"])
      ])
    ]),
    (_ctx.users)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", {
            class: _normalizeClass(["users__table-head", { 'users__table-head--dark': _ctx.tableUtilsVisible }])
          }, [
            (_ctx.tableUtilsVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "users__table-utils-btn button button--green",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setDebugAll && _ctx.setDebugAll(...args)), ["prevent"]))
                  }, _hoisted_22),
                  _createElementVNode("button", {
                    class: "users__table-utils-btn button button--blue",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportUserResults && _ctx.exportUserResults(...args)), ["prevent"]))
                  }, _hoisted_25),
                  _createElementVNode("button", {
                    class: "users__table-utils-btn button button--red",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteUsers && _ctx.deleteUsers(...args)), ["prevent"]))
                  }, _hoisted_28)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.areUsersSelected,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.areUsersSelected) = $event)),
                  binary: true,
                  onClick: _withModifiers(_ctx.toggleAllItems, ["prevent"])
                }, null, 8, ["modelValue", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("button", {
                  class: "users__table-filter",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.changeFilters('email')), ["prevent"]))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-icons", {'enabled': _ctx.filters.email.config.enabled}])
                  }, _toDisplayString(_ctx.filters.email.config.descending ? 'keyboard_arrow_down' : 'keyboard_arrow_up'), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("button", {
                  class: "users__table-filter",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.changeFilters('name')), ["prevent"]))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-icons", {'enabled': _ctx.filters.name.config.enabled}])
                  }, _toDisplayString(_ctx.filters.name.config.descending ? 'keyboard_arrow_down' : 'keyboard_arrow_up'), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("button", {
                  class: "users__table-filter",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.changeFilters('userType')), ["prevent"]))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-icons", {'enabled': _ctx.filters.userType.config.enabled}])
                  }, _toDisplayString(_ctx.filters.userType.config.descending ? 'keyboard_arrow_down' : 'keyboard_arrow_up'), 3)
                ])
              ]),
              _hoisted_37,
              _hoisted_38,
              _hoisted_39
            ])
          ], 2),
          _createElementVNode("div", _hoisted_40, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "users__table-row",
                key: user?.externalId
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_Checkbox, {
                    modelValue: user.selected,
                    "onUpdate:modelValue": ($event: any) => ((user.selected) = $event),
                    binary: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_router_link, {
                    to: { name: 'UserDetailsView', params: {id: user.externalId} },
                    title: user.email
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.email), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "title"])
                ]),
                _createElementVNode("div", _hoisted_43, _toDisplayString(user.name), 1),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.UserType[user.userType]), 1)
                ]),
                _createElementVNode("div", _hoisted_46, _toDisplayString(user.loginCode), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Switch, {
                    modelValue: user.isTester,
                    "onUpdate:modelValue": ($event: any) => ((user.isTester) = $event),
                    onChange: ($event: any) => (_ctx.updateUser(user))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", {
                    class: "users__table-pill pill",
                    style: _normalizeStyle({'background-color': `#${user.group?.color}`})
                  }, _toDisplayString(user.group?.name), 5)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_Pagination, {
          options: _ctx.tableBody,
          maxCount: _ctx.userCount,
          onPaginChange: _ctx.paginChange
        }, null, 8, ["options", "maxCount", "onPaginChange"])
      ])
    ])
  ]))
}